import React from 'react'
import { connect } from 'react-redux'
import { PriceInput } from '../../../../components/FormBuilder'
import { getUserCurrency } from '../../../../reducers/userObject/selectors/object'

const PriceInputWithCurrency = ({ currency, ...rest }) => (
  <PriceInput.ReduxField currency={currency} {...rest} />
)

const PriceInputWithCurrencyF = ({ currency, ...rest }) => (
  <PriceInput.Field currency={currency} {...rest} />
)

const MapCurrencyToProps = state => ({
  currency: getUserCurrency(state),
})

export default connect(MapCurrencyToProps)(PriceInputWithCurrency)
export const PriceInputWithCurrencyField = connect(MapCurrencyToProps)(PriceInputWithCurrencyF)
